import { render, staticRenderFns } from "./renewalFail.vue?vue&type=template&id=08887d0a&scoped=true"
import script from "./renewalFail.vue?vue&type=script&lang=js"
export * from "./renewalFail.vue?vue&type=script&lang=js"
import style0 from "./renewalFail.vue?vue&type=style&index=0&id=08887d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08887d0a",
  null
  
)

export default component.exports